import { Outlet, Navigate } from 'react-router-dom';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { ROUTES } from 'Utils/constants';

export default function GuardWorkspace() {
    const { user } = useUser();

    if (!user) {
        return <Navigate to={ROUTES.signIn} />;
    }

    if (user.set_project_workspace_id != null) {
        return <Navigate to={ROUTES.dashboards} />;
    }

    return <Outlet />;
}
